<template>
  <div class="app-page">
    <PageHeader type="back" :backFun="goBack" />
    <div class="application-page-container">
      <div class="job-info">
        <div class="info-left">
          <div class="jinfo-header default">
            <div class="jinfo-title">{{ $t('user.Messages') }}</div>
            <a-popconfirm
              :title="$t('user.Are you sure delete all selected messages?')"
              @confirm="handleMessageDeleteAll"
              :cancelText="$t('user.Cancel')"
              :okText="$t('user.OK')"
            >
              <a-button>
                <DeleteOutlined />
                {{ $t('user.Delete All') }}
              </a-button>
            </a-popconfirm>
          </div>
          <a-table
            class="record-table"
            :rowKey="(message) => message.id"
            :columns="columns"
            :data-source="messages"
            :pagination="false"
          >
            <template v-slot:emptyText>
              <Empty />
            </template>
            <template v-slot:bodyCell="{ record, column }">
              <template v-if="column.key === 'message'">
                <div
                  style="text-align: left; cursor: pointer"
                  @click="goDetail(record)"
                >
                  {{ record.message }}
                </div>
              </template>
              <template v-else-if="column.key === 'check'">
                <div style="width: 100%; text-align: center">
                  <a-checkbox v-model:checked="record.check"></a-checkbox>
                </div>
              </template>
              <template v-if="column.key === 'action'">
                <a-popconfirm
                  :title="$t('user.Are you sure delete this message?')"
                  :cancelText="$t('user.Cancel')"
                  :okText="$t('user.OK')"
                  @confirm="handleMessageDelete(record)"
                >
                  <a href="#">{{ $t('user.Delete') }}</a>
                </a-popconfirm>
              </template>
              <CommentsEditor
                v-else-if="column.key === 'comments'"
                v-model:text="record[column.key]"
                @ok="submitComment(record)"
                status="edit"
              />
              <template v-else-if="column.key === 'content'">
                <div style="text-align: left">{{ record.content }}</div>
              </template>
            </template>
          </a-table>
          <div class="pagination">
            <div class="page-pagination">
              <a-pagination
                @change="fetchData"
                v-model:current="pagination.current"
                :total="pagination.total"
                v-model:pageSize="pagination.pageSize"
                :pageSizeOptions="pagination.pageSizeOptions"
                size="small"
                show-less-items
                show-size-changer
                show-quick-jumper
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { message } from 'ant-design-vue'
  import { DeleteOutlined } from '@ant-design/icons-vue'

  import CommentsEditor from '@/components/CommentsEditor'
  import PageHeader from '@/components/PageHeader.vue'
  import { getMessagePage, delMessage, delAllMessage } from '@/api/message'
  import avators from '@/assets/avator'
  import Empty from '@/components/Empty'

  export default {
    name: 'Index',
    components: {
      CommentsEditor,
      PageHeader,
      DeleteOutlined,
      Empty,
    },
    data() {
      return {
        loading: false,
        pagination: {
          total: 0,
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '30', '50'],
        },
        columns: [
          {
            title: this.$t('user.Messages'),
            width: 400,
            key: 'message',
            dataIndex: 'message',
          },
          {
            title: this.$t('user.Date'),
            width: 120,
            key: 'time',
            dataIndex: 'time',
          },
          {
            title: this.$t('user.Action'),
            width: 120,
            key: 'action',
            dataIndex: 'action',
          },
        ],
        commentVisible: false,
        commentDialogId: null,
        commentDialogValue: null,
        learningMsg: null,
        isForce: false,
        currentRecord: null,
        messages: [],
      }
    },
    watch: {
      applyNode: {
        handler(data) {
          if (data == 'select') {
            this.$store.commit('routes/setSider', 'me/apply/target')
          } else if (data == 'fill') {
            this.$store.commit('routes/setSider', 'me/apply')
          } else if (data == 'success') {
            this.$store.commit('routes/setSider', 'user')
          }
        },
        immediate: true,
      },
    },
    computed: {
      ...mapGetters({
        username: 'user/username',
      }),
      hasUnfinished() {
        const unfinished = this.jobInfo.jobQualifications.find((item) => {
          return (
            item.check != true && (item.comments == '' || item.comments == null)
          )
        })
        if (unfinished) {
          console.log(unfinished)
        }
        return unfinished != null
      },
    },
    mounted() {
      this.load()
    },
    methods: {
      async load() {
        const res = await this.fetchData()
      },
      goDetail(record) {
        switch (record.type) {
          case 10:
            if (record.apply_id != 0) {
              this.$router.push(`/me/application/detail/${record.apply_id}`)
            }
            break
          case 20:
            if (record.apply_id != 0) {
              this.$router.push(`/teams/detail/${record.apply_id}`)
            }
            break
          case 30:
            if (record.apply_id != 0) {
              this.$router.push(`/me/application/detail/${record.apply_id}`)
            }
            break
          case 40:
            if (record.apply_id != 0) {
              this.$router.push(`/teams/detail/${record.apply_id}`)
            }
            break
          case 50:
            if (record.apply_id != 0) {
              this.$router.push(`/group/detail/${record.apply_id}`)
            }
            break
          case 60:
            if (record.apply_id != 0) {
              this.$router.push(`/group/detail/${record.apply_id}`)
            }
            break
          case 70:
            if (record.apply_id != 0) {
              this.$router.push(`/me/application/detail/${record.apply_id}`)
            }
            break
          case 80:
            this.$router.push(`/teams/list`)
            break
          case 90:
            this.$router.push(`/teams/list`)
            break
          case 100:
            this.$router.push(`/group/list`)
            break
          case 110:
            this.$router.push(`/group/list`)
            break

          default:
            break
        }
        console.log(record)
      },
      goBack() {
        if (this.applyNode == 'select') {
          this.applyNode = 'fill'
        } else {
          this.$router.back()
        }
      },
      setSilderAvator(rolename) {
        if (rolename) {
          const filename = rolename.toLocaleLowerCase().replace(/\s*/g, '')
          this.$store.dispatch('user/setAvator', avators[filename])
        }
      },
      editComment(data) {
        this.commentDialogId = data.id
        this.commentDialogValue = data.comments
        this.commentVisible = true
      },
      submitComment(record) {
        // const current = this.jobInfo.jobQualifications.find(
        //   (item) => item.id === this.commentDialogId
        // )
        // current.comments = this.commentDialogValue
        // this.commentVisible = false
        this.currentRecord = record
        const that = this
        const data = {
          is_forced: this.isForce,
          guide_id: this.jobInfo.id,
          items: this.jobInfo.jobQualifications.map((item) => {
            return {
              id: item.id,
              check: item.check,
              comments: item.comments,
            }
          }),
        }
      },

      async handleMessageDelete(record) {
        console.log(record)
        const res = await delMessage(record.id)
        if (res.code === 200) {
          message.success(this.$t('user.Message deleted'))

          this.load()
        }
      },
      async handleMessageDeleteAll() {
        const res = await delAllMessage()
        if (res.code === 200) {
          message.success(this.$t('user.Message deleted'))
          this.load()
        }
      },
      fetchData() {
        const params = {
          pageSize: this.pagination.pageSize || 10,
          pageNum: this.pagination.current || 1,
          // keywords: this.keyword,
          pagination: this.pagination,
          // filters: this.filteredInfo.status,
        }
        this.loading = true
        return getMessagePage(params)
          .then((res) => {
            if (res.code == 200) {
              this.pagination.total = res.page.total || 0
              this.messages = res.data
            }
            return res
          })
          .finally(() => {
            this.loading = false
          })
      },
    },
  }
</script>

<style lang="less" scoped>
  @import url('@/styles/params.less');
  .application-page-container {
    margin: @app-conetent-margin;
  }
  .search-form {
    display: flex;
    padding: 20px 24px;
    background-color: white;
    margin-bottom: 16px;
    .ant-select {
      width: 200px;
    }
    .ant-form-item-label {
      font-weight: bold;
    }

    &-timeline {
      display: flex;
      flex-direction: column;
      align-items: center;
      box-sizing: border-box;
      padding-top: 6px;
      padding-bottom: 10px;
      .circle {
        width: 10px;
        height: 10px;
        border-radius: 5px;
        background-color: @primary-color;
      }

      .line {
        flex: 1;
        width: 1px;
        background-color: @primary-color;
      }
      margin-right: 10px;
    }

    .current-role {
      &-label {
        margin-right: 8px;
        font-weight: bold;
      }

      &-value {
        color: @primary-color;
      }
      margin-bottom: 10px;
    }
  }
  .item-label-target {
    :deep {
      .ant-form-item-label > label {
        font-weight: bold;
      }
    }
  }
  .target-job-info,
  .job-info {
    display: flex;
    min-height: 530px;
    .info-left {
      background-color: white;
      flex-grow: 7;
      width: 70%;
    }
    .jinfo-theme {
      font-size: 16px;
      color: #333333;
      line-height: 24px;
      font-weight: 700;
      padding: 16px 24px;
    }
    .qualification-list {
      list-style: none;
      padding-left: 40px;
      li {
        font-size: 14px;
        color: #333333;
        letter-spacing: 0;
        line-height: 42px;
        font-weight: 400;
        &.high {
          color: @primary-color;
        }
      }
    }
    .jinfo-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px 24px;
      border-bottom: 1px solid #e9e9e9;
      .jinfo-title {
        font-size: 16px;
        color: #333333;
        line-height: 24px;
        font-weight: 700;
      }
      &.msg {
        margin: 0 24px;
        background-color: #fafafa;
      }
    }

    .jinfo-sub-header {
      padding: 16px 24px;
      .jinfo-title {
        font-size: 16px;
        color: #333333;
        line-height: 24px;
        font-weight: 700;
      }
      &.msg {
        margin: 0 24px;
        background-color: #fafafa;
      }
    }

    .jinfo-content {
      padding: 0px 24px;
      white-space: pre-line;
      &.list {
        padding: 16px 24px;
      }
      &.default {
        padding: 14px 24px;
      }
    }
  }
  .record-table {
    // padding: 0 24px;
  }

  .success-panel {
    background-color: white;
    height: 495px;
    padding-top: 68px;
    text-align: center;
    .svg-icon {
      width: 72px;
      height: 72px;
      color: #43a047;
      margin-bottom: 27px;
    }
    .message {
      font-size: 24px;
      color: #333333;
      line-height: 32px;
      font-weight: 400;
      margin: 6px auto;
    }
    .tips {
      font-size: 14px;
      color: #666666;
      text-align: center;
      line-height: 22px;
    }
    .btn-group-success {
      margin-top: 60px;
      display: flex;
      justify-content: center;
      .btn-view,
      .btn-back {
        margin: 0 8px;
      }
    }
  }
  .pagination {
    text-align: right;
    padding: 24px;
    ul {
      text-align: right;
    }
  }
</style>
